(function () {
	angular
		.module('trackeye')
		.factory('ImageResizer', _ImageResizerFactory);

	_ImageResizerFactory.$inject = ["$q"];

	function _ImageResizerFactory($q) {
		function ImageResizer(file, max_width, max_height) {
			this.maxWidth = max_width || 300;
			this.maxHeight = max_height || 150;
			this.deferred = $q.defer();

			var reader = new FileReader(file);

			reader.onload = (function () {
				this._render(reader.result, file.type);
			}).bind(this);

			reader.readAsDataURL(file);
		}

		ImageResizer.prototype.ready = function () {
			return this.deferred.promise;
		};

		ImageResizer.prototype._render = function (data, file_type) {
			var image = new Image(),
				canvas = document.createElement('canvas'),
				context = canvas.getContext('2d');


			image.onload = (function () {
				var aspect = this.calcAspectRatioFit(image.width, image.height);

				// Canvas apparently affects the resizing.
				canvas.width = aspect.width;
				canvas.height = aspect.height;

				context.drawImage(image, 	0, 0, image.width, image.height, 	// source
											0, 0, aspect.width, aspect.height); // destination

				var base64_data = canvas.toDataURL().match(/data.+\,(.+)/);

				if (base64_data) {
					this.deferred.resolve({
						data: base64_data[1],
						type: file_type,
						ext: file_type.split('/')[1]
					});
				} else {
					this.deferred.reject(false);
				}
			}).bind(this);

			image.src = data;
		};

		ImageResizer.prototype.calcAspectRatioFit = function (src_w, src_h) {
			if (src_w < this.maxWidth && src_h < this.maxHeight) {
				return {
					width: src_w,
					height: src_h
				};
			}

			var ratio = Math.min(this.maxWidth / src_w, this.maxHeight / src_h);

			return {
				width: src_w * ratio,
				height: src_h * ratio
			};
		};

		return ImageResizer;
	}
}());